import { Component, Input, EventEmitter, Output } from '@angular/core';

import { GenericValue } from 'hisng';

import { Person } from 'app/fs/res/common/model/person/person';
import { PatentInventor } from 'app/fs/res/patent/model/patent/patent-classes';

@Component( {
    selector: 'res-patent-search-internal-person-inventor',
    templateUrl: './patent-search-internal-person-inventor.component.html',
} )
export class PatentSearchInternalPersonInventorComponent {
    @Input() patentInventor: PatentInventor;
    @Output() submitPatentInventor: EventEmitter<void> = new EventEmitter();

    public onSubmitSelection( event: any[] ) {
        this.setPatentInventorOrganization( event[0] );
        this.setPatentInventorPerson( event[0] );

        this.submitPatentInventor.emit();
    }

    /** set PatentInventor.organization */
    private setPatentInventorOrganization( searchResultOption: any ): void {
        let orgUnit = new GenericValue();
        orgUnit.id = searchResultOption['[PersonOrgunitRelation].orgunitObj.currentVersions.id'];
        orgUnit.text = searchResultOption['[PersonOrgunitRelation].orgunitObj.currentVersions.defaulttext'];

        this.patentInventor.organization = orgUnit;
    }

    /** set PatentInventor.person */
    private setPatentInventorPerson( searchResultOption: any ): void {
        let person = new Person();
        person.id = searchResultOption['Person.id'];
        person.firstname = searchResultOption['Person.firstname'];
        person.surname = searchResultOption['Person.surname'];

        this.patentInventor.person = person;
    }
}
